module.exports = __webpack_public_path__ + "img/ic-popular-inactive.a4f91744.svg";